import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";


import "./Demo_Product.css";
import { Link, useNavigate } from "react-router-dom";
import { Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/navigation';
import "swiper/css/pagination";

function Demo_Product({ products, breakpoints, setSelectId, selectId }) {
  const navigate = useNavigate();
  return (
    <section className="Demo_Product_holder">
      <div className="container">
        <div className="Demo_Product_holder_swiper_holder">
          <Swiper
            modules={[Pagination, Navigation]}
            navigation={true}
            spaceBetween={10}
            slidesPerView={4}
            pagination={{ clickable: true }}
            breakpoints={breakpoints}
          >

            {/* <SwiperSlide>
                <div className="Demo_Product">
                  <div className="product-card">
                    <div
                      className="img_holder"
                      // onClick={() =>
                      //   navigate(`/categories?category_id=${product?.id}`)
                      // }
                      //  onClick={() =>
                      //  setSelectId(product?.id)
                      // }
                    >
                   
                 
                     
                    </div>

                    <p className="product-name">ALL PRODUCTS</p>
                  </div>
                </div>
              </SwiperSlide>
             */}
            {products?.map((product, index) => (
              <SwiperSlide key={index}>
                <div className="Demo_Product">
                  <div className="product-card">
                    <div
                      className="img_holder"
                      // onClick={() =>
                      //   navigate(`/categories?category_id=${product?.id}`)
                      // }
                      onClick={() =>
                        setSelectId(product?.id)
                      }
                    >

                      <img
                        className="Product_img"
                        src={process.env.REACT_APP_IMG_URL + product.image}
                        alt={product.name}
                      />

                    </div>

                    <p className="product-name para_text">{product.name}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Demo_Product;
